
   // const var_api = 'http://localhost:4500/v1/';
   // const image_api = 'http://localhost:4500/';


   //  const image_api = 'http://api.theherbandwatercompany.com/';
   //  const var_api = 'http://api.theherbandwatercompany.com/v1/';


   //  const var_api = 'http://postestapi.suyaptech.com';
    //  const var_api = "https://api.spbiller.com";
   //  const var_api = 'http://139.59.61.131:4501';

   // const image_api = 'http://doctorapi.suyaptech.com:5006/';
   // const var_api = 'http://doctorapi.suyaptech.com:5006/v1/';

     const image_api = 'https://api.thatwc.com/';
   const var_api = 'https://api.thatwc.com/v1/';



    export { var_api, image_api }


